let instance;
import { Loader } from '@googlemaps/js-api-loader';
const initializeGoogleLoader = (apiKey) => {
  if (!instance) {
    instance = new Loader({
      apiKey: apiKey,
      libraries: [
        'core',
        'maps',
        'places',
        'geocoding',
        'routes',
        'marker',
        'geometry',
        'elevation',
        'streetView',
        'journeySharing',
        'drawing',
        'visualization'
      ]
    });
  }

  return instance;
};

export { initializeGoogleLoader };
